import { render, staticRenderFns } from "./ContactRole.vue?vue&type=template&id=59725dd5&"
import script from "./ContactRole.vue?vue&type=script&lang=js&"
export * from "./ContactRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports